module.exports = __webpack_public_path__ + "media/img/payments/logo-14f90189051019b6facb77d5e73079af.svg";